import { z } from 'zod';
import { OrderDirection } from '@/constants/orderDirection';
import { ACCOUNT_ORDER_BY, ACCOUNT_TAB_FILTER } from './-constants';
export const SearchSchema = z.object({
  tab: z.nativeEnum(ACCOUNT_TAB_FILTER).default(ACCOUNT_TAB_FILTER.ALL),
  pageSize: z.number().int().min(1).default(100),
  pageIndex: z.number().int().min(0).default(0),
  orderBy: z.nativeEnum(ACCOUNT_ORDER_BY).optional(),
  orderDirection: z.nativeEnum(OrderDirection).optional(),
  freeText: z.string().optional()
});
export type SearchSchema = z.infer<typeof SearchSchema>;